import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMeldungStatusArtListStatus: 'idle',
    loadMeldungStatusArtListError: undefined as any,
    loadMeldungStatusArtListLastArgs: undefined as any,
    loadMeldungStatusArtStatus: 'idle',
    loadMeldungStatusArtError: undefined as any,
    saveMeldungStatusArtStatus: 'idle',
    saveMeldungStatusArtError: undefined as any,
    deleteMeldungStatusArtStatus: 'idle',
    deleteMeldungStatusArtError: undefined as any,

    meldungStatusArtList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungStatusArtList = createAsyncThunk('meldungStatusArtSlice/loadMeldungStatusArtList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungStatusArtSlice.loadMeldungStatusArtListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldstatart/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungStatusArtListStatus } = getState().meldungStatusArtSlice
        return loadMeldungStatusArtListStatus !== 'pending'
    }
})

export const loadMeldungStatusArt = createAsyncThunk('meldungStatusArtSlice/loadMeldungStatusArt', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldstatart/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungStatusArtStatus } = getState().meldungStatusArtSlice
        return loadMeldungStatusArtStatus !== 'pending'
    }
})

export const saveMeldungStatusArt = createAsyncThunk('meldungStatusArtSlice/saveMeldungStatusArt', async ({ meldungStatusArt }: any, { rejectWithValue }: any) => {
    let promises = []
    if (meldungStatusArt?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurismeldstatart/${ meldungStatusArt?.HDR_ID }/`,
            prepareData(meldungStatusArt),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurismeldstatart/`,
            prepareData(meldungStatusArt),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungStatusArtStatus } = getState().meldungStatusArtSlice
        return saveMeldungStatusArtStatus !== 'pending'
    }
})

export const deleteMeldungStatusArt = createAsyncThunk('meldungStatusArtSlice/deleteMeldungStatusArt', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurismeldstatart/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungStatusArtStatus } = getState().meldungStatusArtSlice
        return deleteMeldungStatusArtStatus !== 'pending'
    }
})

const MeldungStatusArtSlice = createSlice({
    name: 'meldungStatusArtSlice',
    initialState,
    reducers: {
        resetloadMeldungStatusArtListError: (state) => {
            state.loadMeldungStatusArtListError = undefined
        },
        resetloadMeldungStatusArt: (state) => {
            state.formItem = undefined
            state.loadMeldungStatusArtError = undefined
        },
        resetloadMeldungStatusArtError: (state) => {
            state.loadMeldungStatusArtError = undefined
        },
        resetsaveMeldungStatusArt: (state) => {
            state.formItem = undefined
            state.saveMeldungStatusArtError = undefined
        },
        resetsaveMeldungStatusArtError: (state) => {
            state.saveMeldungStatusArtError = undefined
        },
        resetdeleteMeldungStatusArtError: (state) => {
            state.deleteMeldungStatusArtError = undefined
        },
        removeFromMeldungStatusArtListById: (state, action) => {
            state.meldungStatusArtList = state.meldungStatusArtList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungStatusArtListByIds: (state, action) => {
            state.meldungStatusArtList = state.meldungStatusArtList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungStatusArtList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungStatusArtListStatus = 'preloaded'
            state.loadMeldungStatusArtListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungStatusArtList = []
            state.loadMeldungStatusArtListStatus = 'idle'
            state.loadMeldungStatusArtListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungStatusArtList.pending, (state) => {
            state.loadMeldungStatusArtListStatus = 'pending'
            state.loadMeldungStatusArtListError = undefined
        })
        builder.addCase(loadMeldungStatusArtList.fulfilled, (state, action) => {
            state.loadMeldungStatusArtListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungStatusArtListLastArgs = action.payload.args

            {
                state.meldungStatusArtList = action.payload.data

            }
        })
        builder.addCase(loadMeldungStatusArtList.rejected, (state, action) => {
            state.loadMeldungStatusArtListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungStatusArtListError = action.error.message
            } else {
                state.loadMeldungStatusArtListError = action.payload
            }
        })

        builder.addCase(loadMeldungStatusArt.pending, (state) => {
            state.loadMeldungStatusArtStatus = 'pending'
            state.loadMeldungStatusArtError = undefined
        })
        builder.addCase(loadMeldungStatusArt.fulfilled, (state, action) => {
            state.loadMeldungStatusArtStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungStatusArtList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungStatusArtList.push(newItem) }
                else { state.meldungStatusArtList[i] = { ...state.meldungStatusArtList[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldungStatusArt.rejected, (state, action) => {
            state.loadMeldungStatusArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungStatusArtError = action.error.message
            } else {
                state.loadMeldungStatusArtError = action.payload
            }
        })

        builder.addCase(saveMeldungStatusArt.pending, (state) => {
            state.saveMeldungStatusArtStatus = 'pending'
            state.saveMeldungStatusArtError = undefined
        })
        builder.addCase(saveMeldungStatusArt.fulfilled, (state, action) => {
            state.saveMeldungStatusArtStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungStatusArtList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungStatusArtList.push(newItem) }
                else { state.meldungStatusArtList[i] = { ...state.meldungStatusArtList[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldungStatusArt.rejected, (state, action) => {
            state.saveMeldungStatusArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungStatusArtError = action.error.message
            } else {
                state.saveMeldungStatusArtError = action.payload
            }
        })

        builder.addCase(deleteMeldungStatusArt.pending, (state) => {
            state.deleteMeldungStatusArtStatus = 'pending'
            state.deleteMeldungStatusArtError = undefined
        })
        builder.addCase(deleteMeldungStatusArt.fulfilled, (state, action) => {
            state.deleteMeldungStatusArtStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungStatusArtList = state.meldungStatusArtList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungStatusArtList = state.meldungStatusArtList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldungStatusArt.rejected, (state, action) => {
            state.deleteMeldungStatusArtStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungStatusArtError = action.error.message
            } else {
                state.deleteMeldungStatusArtError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungStatusArtListError,
    resetloadMeldungStatusArt,
    resetloadMeldungStatusArtError,
    resetsaveMeldungStatusArt,
    resetsaveMeldungStatusArtError,
    resetdeleteMeldungStatusArtError,
    removeFromMeldungStatusArtListById,
    removeFromMeldungStatusArtListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungStatusArtSlice.actions
export default MeldungStatusArtSlice.reducer
